import { useState } from "react";

// ─────────────────────────────────────────────
// 🔴 REPLACE THIS with your real Formspree ID
// Steps: go to formspree.io → New Form → copy the ID from the endpoint URL
// e.g. if your endpoint is https://formspree.io/f/maqzebaz  →  put "maqzebaz"
const FORMSPREE_ID = "maqzebaz";
// ─────────────────────────────────────────────

const STEPS = [
  { id: 1, label: "Personal",   icon: "👤" },
  { id: 2, label: "Academic",   icon: "🎓" },
  { id: 3, label: "Medical",    icon: "🩺" },
  { id: 4, label: "Documents",  icon: "📄" },
  { id: 5, label: "Review",     icon: "✅" },
];

const pink     = "#E91E8C";
const blue     = "#1565C0";
const white    = "#FFFFFF";
const offWhite = "#F8FAFF";
const bg       = "#F0F4FF";
const textDark = "#1A1A3E";
const muted    = "#6B7AA1";
const border   = "rgba(21,101,192,0.15)";
const blueBg   = "rgba(21,101,192,0.08)";
const pinkBg   = "rgba(233,30,140,0.08)";

const baseInput = {
  width: "100%", padding: "11px 14px", background: offWhite,
  border: "1.5px solid rgba(21,101,192,0.15)", borderRadius: "10px",
  color: textDark, fontSize: "14px", outline: "none",
  transition: "border-color 0.2s, box-shadow 0.2s",
  boxSizing: "border-box", fontFamily: "'Plus Jakarta Sans', sans-serif",
};

function Field({ label, type = "text", name, value, onChange, options, placeholder, required }) {
  const [focused, setFocused] = useState(false);
  const style = {
    ...baseInput,
    borderColor: focused ? pink : "rgba(21,101,192,0.15)",
    boxShadow:   focused ? "0 0 0 3px rgba(233,30,140,0.08)" : "none",
  };
  return (
    <div style={{ marginBottom: "18px" }}>
      <label style={{ display:"block", fontSize:"11px", fontWeight:700, letterSpacing:"0.08em", textTransform:"uppercase", color:blue, marginBottom:"6px" }}>
        {label}{required && <span style={{ color:pink, marginLeft:"3px" }}>*</span>}
      </label>
      {type === "select" ? (
        <select name={name} value={value} onChange={onChange} style={{ ...style, cursor:"pointer" }}
          onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}>
          <option value="">— Select —</option>
          {options.map(o => <option key={o} value={o}>{o}</option>)}
        </select>
      ) : type === "textarea" ? (
        <textarea name={name} value={value} onChange={onChange} placeholder={placeholder}
          rows={4} style={{ ...style, resize:"vertical" }}
          onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} />
      ) : (
        <input type={type} name={name} value={value} onChange={onChange} placeholder={placeholder}
          style={style} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} />
      )}
    </div>
  );
}

function StepIndicator({ current }) {
  return (
    <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"center" }}>
      {STEPS.map((step, i) => (
        <div key={step.id} style={{ display:"flex", alignItems:"center" }}>
          <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:"6px" }}>
            <div style={{
              width:"44px", height:"44px", borderRadius:"50%",
              background: current === step.id ? "linear-gradient(135deg,#E91E8C,#C2185B)" : current > step.id ? blue : white,
              border: current === step.id ? "3px solid #E91E8C" : current > step.id ? "3px solid #1565C0" : "2.5px solid rgba(21,101,192,0.15)",
              display:"flex", alignItems:"center", justifyContent:"center",
              fontSize:"18px", transition:"all 0.3s",
              boxShadow: current === step.id ? "0 4px 16px rgba(233,30,140,0.3)" : "none",
              color: current > step.id ? white : "inherit", fontWeight:700,
            }}>
              {current > step.id ? "✓" : step.icon}
            </div>
            <span style={{ fontSize:"10px", fontWeight:700, letterSpacing:"0.05em", textTransform:"uppercase", whiteSpace:"nowrap", color: current >= step.id ? (current === step.id ? pink : blue) : muted }}>
              {step.label}
            </span>
          </div>
          {i < STEPS.length - 1 && (
            <div style={{ width:"32px", height:"3px", marginBottom:"20px", transition:"background 0.3s", background: current > step.id ? "linear-gradient(90deg,#1565C0,#42A5F5)" : "rgba(21,101,192,0.12)" }} />
          )}
        </div>
      ))}
    </div>
  );
}

function SectionHead({ title, subtitle, accent, icon }) {
  return (
    <div style={{ display:"flex", alignItems:"flex-start", gap:"14px", marginBottom:"28px" }}>
      <div style={{ width:"44px", height:"44px", borderRadius:"12px", flexShrink:0, background: accent === pink ? pinkBg : blueBg, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"22px" }}>{icon}</div>
      <div>
        <h2 style={{ fontFamily:"'Playfair Display',serif", color:textDark, fontSize:"20px", fontWeight:700, margin:"0 0 4px" }}>{title}</h2>
        <p style={{ color:muted, fontSize:"13px", margin:0 }}>{subtitle}</p>
      </div>
    </div>
  );
}

function ReviewSection({ title, accent, children }) {
  return (
    <div style={{ marginBottom:"20px" }}>
      <p style={{ color:accent, fontSize:"11px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.1em", margin:"0 0 8px" }}>{title}</p>
      <div style={{ background:offWhite, borderRadius:"12px", padding:"4px 16px", border:"1px solid rgba(21,101,192,0.1)" }}>{children}</div>
    </div>
  );
}

function RRow({ label, value }) {
  return (
    <div style={{ display:"flex", justifyContent:"space-between", padding:"10px 0", borderBottom:"1px solid rgba(21,101,192,0.08)" }}>
      <span style={{ color:muted, fontSize:"13px", fontWeight:600 }}>{label}</span>
      <span style={{ color:textDark, fontSize:"13px", maxWidth:"60%", textAlign:"right" }}>{value || "—"}</span>
    </div>
  );
}

function LogoBadge({ size = 46 }) {
  return (
    <div style={{ width:size, height:size, borderRadius:"50%", flexShrink:0, background:"linear-gradient(135deg,#fff 40%,#E91E8C 130%)", border:"2.5px solid rgba(255,255,255,0.55)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:size*0.42, boxShadow:"0 2px 8px rgba(0,0,0,0.15)" }}>⚕️</div>
  );
}

const INIT = {
  firstName:"", lastName:"", dob:"", gender:"", nationality:"", idNumber:"",
  phone:"", email:"", address:"", city:"", province:"",
  highSchool:"", graduationYear:"", mathGrade:"", scienceGrade:"", englishGrade:"",
  overallAverage:"", extraCurricular:"",
  hasCondition:"", conditions:"", medications:"", allergies:"",
  emergencyName:"", emergencyRelation:"", emergencyPhone:"",
  idDoc:false, transcript:false, photo:false, medicalCert:false, motivationLetter:false,
  agreeTerms:false,
};

export default function App() {
  const [step,      setStep]      = useState(1);
  const [form,      setForm]      = useState(INIT);
  const [submitted, setSubmitted] = useState(false);
  const [sending,   setSending]   = useState(false);
  const [error,     setError]     = useState("");
  const [appRef]                  = useState(() => "EHHI-NL1-" + Math.floor(100000 + Math.random() * 900000));

  const handle = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

  // ── Formspree submission ──────────────────────────────────────────────────
  const handleSubmit = async () => {
    if (!form.agreeTerms) return;
    setSending(true);
    setError("");

    // Build a clean flat object with readable labels for the Formspree email
    const payload = {
      // Meta
      _subject:              `EHHI Nursing L1 Application — ${form.firstName} ${form.lastName} [${appRef}]`,
      "Application Ref":     appRef,
      // Personal
      "First Name":          form.firstName,
      "Last Name":           form.lastName,
      "Date of Birth":       form.dob,
      "Gender":              form.gender,
      "Nationality":         form.nationality,
      "ID / Passport":       form.idNumber,
      "Phone":               form.phone,
      "Email":               form.email,
      "Address":             form.address,
      "City":                form.city,
      "Province / Region":   form.province,
      // Academic
      "High School":         form.highSchool,
      "Graduation Year":     form.graduationYear,
      "Overall Average":     form.overallAverage ? form.overallAverage + "%" : "",
      "Maths Grade":         form.mathGrade,
      "Biology Grade":       form.scienceGrade,
      "English Grade":       form.englishGrade,
      "Extra-Curricular":    form.extraCurricular,
      // Medical
      "Pre-existing Conditions": form.hasCondition === "Yes" ? form.conditions : "None",
      "Medications":         form.medications,
      "Allergies":           form.allergies,
      // Emergency
      "Emergency Contact":   form.emergencyName,
      "Emergency Relation":  form.emergencyRelation,
      "Emergency Phone":     form.emergencyPhone,
      // Documents
      "Doc — ID / Passport":     form.idDoc            ? "Confirmed" : "Not confirmed",
      "Doc — Transcript":        form.transcript        ? "Confirmed" : "Not confirmed",
      "Doc — Photograph":        form.photo             ? "Confirmed" : "Not confirmed",
      "Doc — Medical Cert":      form.medicalCert       ? "Confirmed" : "Not confirmed",
      "Doc — Motivation Letter": form.motivationLetter  ? "Confirmed" : "Not confirmed",
    };

    try {
      const res = await fetch(`https://formspree.io/f/${FORMSPREE_ID}`, {
        method:  "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body:    JSON.stringify(payload),
      });

      if (res.ok) {
        setSubmitted(true);
      } else {
        const data = await res.json();
        setError(data?.errors?.[0]?.message || "Submission failed. Please try again.");
      }
    } catch {
      setError("Network error. Please check your connection and try again.");
    } finally {
      setSending(false);
    }
  };
  // ─────────────────────────────────────────────────────────────────────────

  if (submitted) {
    return (
      <div style={{ minHeight:"100vh", background:bg, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Plus Jakarta Sans',sans-serif", padding:"20px" }}>
        <style>{`@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&family=Playfair+Display:wght@700;800&display=swap'); @keyframes fadeUp{from{opacity:0;transform:translateY(18px)}to{opacity:1;transform:translateY(0)}}`}</style>
        <div style={{ background:white, borderRadius:"24px", padding:"52px 40px", textAlign:"center", maxWidth:"500px", width:"100%", boxShadow:"0 20px 60px rgba(21,101,192,0.12)", border:"1px solid rgba(21,101,192,0.1)", animation:"fadeUp 0.5s ease" }}>
          <div style={{ display:"flex", justifyContent:"center", marginBottom:"16px" }}><LogoBadge size={72} /></div>
          <div style={{ fontSize:"42px", marginBottom:"10px" }}>🎉</div>
          <h2 style={{ color:pink, fontSize:"26px", fontWeight:800, margin:"0 0 10px", fontFamily:"'Playfair Display',serif" }}>Application Submitted!</h2>
          <p style={{ color:muted, lineHeight:1.7, fontSize:"15px", margin:"0 0 24px" }}>
            Thank you, <strong style={{ color:textDark }}>{form.firstName} {form.lastName}</strong>.<br />
            Your application for <strong style={{ color:blue }}>Nursing Level 1</strong> at EHHI has been received.
          </p>
          <div style={{ background:"linear-gradient(135deg,rgba(233,30,140,0.06),rgba(21,101,192,0.06))", border:"1.5px dashed "+pink, borderRadius:"14px", padding:"18px 24px", marginBottom:"20px" }}>
            <p style={{ margin:0, color:muted, fontSize:"11px", letterSpacing:"0.1em", textTransform:"uppercase", fontWeight:700 }}>Reference Number</p>
            <p style={{ margin:"6px 0 0", color:pink, fontSize:"24px", fontWeight:800, letterSpacing:"0.05em" }}>{appRef}</p>
          </div>
          <p style={{ color:muted, fontSize:"13px", lineHeight:1.6, marginBottom:"28px" }}>
            A confirmation will be sent to <strong style={{ color:blue }}>{form.email}</strong>.<br />
            Our admissions team will respond within <strong>5–7 business days</strong>.
          </p>
          <button onClick={() => { setForm(INIT); setStep(1); setSubmitted(false); }} style={{ padding:"12px 32px", background:"linear-gradient(135deg,#E91E8C,#C2185B)", border:"none", borderRadius:"10px", color:white, fontWeight:700, fontSize:"14px", cursor:"pointer", fontFamily:"'Plus Jakarta Sans',sans-serif", boxShadow:"0 4px 16px rgba(233,30,140,0.3)" }}>
            New Application
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&family=Playfair+Display:wght@700;800&display=swap');
        * { box-sizing:border-box; }
        input::placeholder,textarea::placeholder { color:#A0AABF; }
        ::-webkit-scrollbar{width:5px} ::-webkit-scrollbar-thumb{background:#E91E8C;border-radius:3px}
        @keyframes slideIn{from{opacity:0;transform:translateX(12px)}to{opacity:1;transform:translateX(0)}}
        .sa{animation:slideIn 0.3s ease}
        button{transition:opacity 0.15s} button:hover:not(:disabled){opacity:0.86!important}
      `}</style>

      {/* HEADER */}
      <header style={{ background:"linear-gradient(135deg,#1565C0,#0D47A1)", padding:"0 32px", position:"sticky", top:0, zIndex:100, display:"flex", alignItems:"center", justifyContent:"space-between", height:"68px", boxShadow:"0 2px 20px rgba(21,101,192,0.4)" }}>
        <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
          <LogoBadge size={44} />
          <div>
            <div style={{ color:white, fontWeight:800, fontSize:"15px", lineHeight:1.1 }}>Essential Health Higher Institute</div>
            <div style={{ color:"rgba(255,255,255,0.6)", fontSize:"11px", letterSpacing:"0.05em" }}>EHHI · EHFAF</div>
          </div>
        </div>
        <div style={{ background:"linear-gradient(135deg,#E91E8C,#C2185B)", borderRadius:"20px", padding:"7px 16px", color:white, fontSize:"11px", fontWeight:700, letterSpacing:"0.07em", boxShadow:"0 3px 12px rgba(233,30,140,0.4)", whiteSpace:"nowrap" }}>
          NURSING LEVEL 1 · 22026/2027
        </div>
      </header>

      {/* HERO */}
      <div style={{ background:"linear-gradient(135deg,#1565C0 0%,#E91E8C 100%)", padding:"40px 24px 64px", textAlign:"center", position:"relative", overflow:"hidden" }}>
        <div style={{ position:"absolute", top:"-40px", right:"-60px", width:"220px", height:"220px", borderRadius:"50%", background:"rgba(255,255,255,0.05)" }} />
        <div style={{ position:"absolute", bottom:"-60px", left:"-40px", width:"180px", height:"180px", borderRadius:"50%", background:"rgba(255,255,255,0.04)" }} />
        <p style={{ color:"rgba(255,255,255,0.8)", fontSize:"12px", fontWeight:700, letterSpacing:"0.2em", textTransform:"uppercase", margin:"0 0 10px" }}>Online Admission Application</p>
        <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(26px,5vw,38px)", fontWeight:800, color:white, margin:"0 0 12px", lineHeight:1.2 }}>Begin Your Nursing Journey</h1>
        <p style={{ color:"rgba(255,255,255,0.78)", fontSize:"14px", lineHeight:1.6, maxWidth:"440px", margin:"0 auto" }}>
          Complete all five sections to apply for the <strong style={{ color:white }}>Nursing Level 1 Programme</strong> at EHHI.
        </p>
      </div>

      {/* MAIN CARD */}
      <div style={{ maxWidth:"740px", margin:"-28px auto 60px", padding:"0 16px" }}>
        <div style={{ background:white, borderRadius:"20px", boxShadow:"0 8px 40px rgba(21,101,192,0.12)", border:"1px solid rgba(21,101,192,0.1)", overflow:"hidden" }}>

          <div style={{ background:offWhite, padding:"28px 32px 24px", borderBottom:"1px solid rgba(21,101,192,0.1)" }}>
            <StepIndicator current={step} />
          </div>

          <div style={{ padding:"clamp(24px,5vw,40px)" }}>

            {/* ── STEP 1 ── */}
            {step === 1 && (
              <div className="sa">
                <SectionHead title="Personal Information" subtitle="Your basic details and contact information" accent={blue} icon="👤" />
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 20px" }}>
                  <Field label="First Name"        name="firstName"  value={form.firstName}  onChange={handle} placeholder="e.g. Amara"                  required />
                  <Field label="Last Name"         name="lastName"   value={form.lastName}   onChange={handle} placeholder="e.g. Nkosi"                   required />
                  <Field label="Date of Birth"     name="dob"        value={form.dob}        onChange={handle} type="date"                                required />
                  <Field label="Gender"            name="gender"     value={form.gender}     onChange={handle} type="select" options={["Female","Male","Non-binary","Prefer not to say"]} required />
                  <Field label="Nationality"       name="nationality" value={form.nationality} onChange={handle} placeholder="e.g. Cameroonian"            required />
                  <Field label="ID / Passport No." name="idNumber"   value={form.idNumber}   onChange={handle} placeholder="National ID or passport"       required />
                  <Field label="Phone Number"      name="phone"      value={form.phone}      onChange={handle} type="tel" placeholder="+237 000 000 0000"  required />
                  <Field label="Email Address"     name="email"      value={form.email}      onChange={handle} type="email" placeholder="you@example.com"  required />
                </div>
                <Field label="Street Address"    name="address"  value={form.address}  onChange={handle} placeholder="123 Main Street" />
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 20px" }}>
                  <Field label="City / Town"       name="city"     value={form.city}     onChange={handle} placeholder="e.g. Yaoundé" />
                  <Field label="Province / Region" name="province" value={form.province} onChange={handle} type="select"
                    options={["Centre","Littoral","West","Adamawa","North West","South West","Far North","East","South","North","Other"]} />
                </div>
              </div>
            )}

            {/* ── STEP 2 ── */}
            {step === 2 && (
              <div className="sa">
                <SectionHead title="Academic Background" subtitle="Your GCE / high school results and qualifications" accent={blue} icon="🎓" />
                <Field label="High School / College Name" name="highSchool" value={form.highSchool} onChange={handle} placeholder="Name of your secondary school" required />
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 20px" }}>
                  <Field label="Graduation Year"  name="graduationYear" value={form.graduationYear} onChange={handle} type="select" options={["2025","2024","2023","2022","2021","2020","2019","Earlier"]} required />
                  <Field label="Overall Average (%)" name="overallAverage" value={form.overallAverage} onChange={handle} type="number" placeholder="e.g. 68" />
                  <Field label="Mathematics Grade" name="mathGrade"    value={form.mathGrade}    onChange={handle} type="select" options={["A (80–100%)","B (70–79%)","C (60–69%)","D (50–59%)","E (40–49%)","F (30–39%)","Below 30%"]} required />
                  <Field label="Biology / Life Sciences Grade" name="scienceGrade" value={form.scienceGrade} onChange={handle} type="select" options={["A (80–100%)","B (70–79%)","C (60–69%)","D (50–59%)","E (40–49%)","F (30–39%)","Below 30%"]} required />
                </div>
                <Field label="English Language Grade" name="englishGrade" value={form.englishGrade} onChange={handle} type="select" options={["A (80–100%)","B (70–79%)","C (60–69%)","D (50–59%)","E (40–49%)","F (30–39%)","Below 30%"]} required />
                <Field label="Extra-Curricular Activities / Achievements" name="extraCurricular" value={form.extraCurricular} onChange={handle} type="textarea" placeholder="Sports, community service, leadership roles, awards..." />
              </div>
            )}

            {/* ── STEP 3 ── */}
            {step === 3 && (
              <div className="sa">
                <SectionHead title="Medical Information" subtitle="Required for student health and safety compliance" accent={pink} icon="🩺" />
                <Field label="Do you have any pre-existing medical conditions?" name="hasCondition" value={form.hasCondition} onChange={handle} type="select" options={["No","Yes"]} required />
                {form.hasCondition === "Yes" && (
                  <Field label="Please describe your condition(s)" name="conditions" value={form.conditions} onChange={handle} type="textarea" placeholder="Describe any chronic or recurring conditions..." />
                )}
                <Field label="Current Medications (if any)" name="medications" value={form.medications} onChange={handle} placeholder="List medications or write 'None'" />
                <Field label="Known Allergies"              name="allergies"   value={form.allergies}   onChange={handle} placeholder="Food, medication, latex — or write 'None'" />
                <div style={{ margin:"28px 0 16px", borderTop:"1px solid rgba(21,101,192,0.1)", paddingTop:"24px" }}>
                  <p style={{ color:blue, fontSize:"12px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.08em", margin:"0 0 16px" }}>🚨 Emergency Contact</p>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 20px" }}>
                  <Field label="Full Name"     name="emergencyName"     value={form.emergencyName}     onChange={handle} placeholder="Contact person" required />
                  <Field label="Relationship"  name="emergencyRelation" value={form.emergencyRelation} onChange={handle} type="select" options={["Parent","Guardian","Sibling","Spouse/Partner","Friend","Other"]} required />
                </div>
                <Field label="Emergency Phone Number" name="emergencyPhone" value={form.emergencyPhone} onChange={handle} type="tel" placeholder="+237 000 000 0000" required />
              </div>
            )}

            {/* ── STEP 4 ── */}
            {step === 4 && (
              <div className="sa">
                <SectionHead title="Required Documents" subtitle="Confirm which documents you will submit with your application" accent={pink} icon="📄" />
                <div style={{ color:muted, fontSize:"13px", marginBottom:"20px", lineHeight:1.6, background:blueBg, padding:"12px 16px", borderRadius:"10px", borderLeft:"3px solid "+blue }}>
                  ℹ️ Physical copies must be delivered to the EHHI Admissions Office within <strong>5 working days</strong>.
                </div>
                {[
                  { name:"idDoc",           label:"Certified Copy of ID / Passport",                    req:true  },
                  { name:"transcript",      label:"Official GCE / Academic Transcript",                  req:true  },
                  { name:"photo",           label:"2 Recent Passport-size Photographs",                  req:true  },
                  { name:"medicalCert",     label:"Medical Fitness Certificate (registered practitioner)", req:true  },
                  { name:"motivationLetter",label:"Motivation Letter — Why you want to study nursing",    req:false },
                ].map(doc => (
                  <label key={doc.name} style={{ display:"flex", alignItems:"flex-start", gap:"14px", padding:"14px 18px", marginBottom:"10px", cursor:"pointer", background:form[doc.name]?(doc.req?blueBg:pinkBg):offWhite, border:"1.5px solid "+(form[doc.name]?(doc.req?blue:pink):border), borderRadius:"12px", transition:"all 0.2s" }}>
                    <input type="checkbox" name={doc.name} checked={form[doc.name]} onChange={handle}
                      style={{ marginTop:"2px", accentColor:doc.req?blue:pink, width:"17px", height:"17px", cursor:"pointer" }} />
                    <div>
                      <span style={{ color:textDark, fontSize:"14px", fontWeight:500 }}>{doc.label}</span>
                      <span style={{ marginLeft:"8px", fontSize:"10px", fontWeight:700, letterSpacing:"0.05em", color:doc.req?blue:pink, background:doc.req?blueBg:pinkBg, padding:"2px 8px", borderRadius:"4px" }}>
                        {doc.req ? "REQUIRED" : "OPTIONAL"}
                      </span>
                    </div>
                  </label>
                ))}
                <label style={{ display:"flex", alignItems:"flex-start", gap:"14px", padding:"16px 18px", marginTop:"20px", cursor:"pointer", background:form.agreeTerms?"rgba(233,30,140,0.05)":offWhite, border:"1.5px solid "+(form.agreeTerms?pink:border), borderRadius:"12px" }}>
                  <input type="checkbox" name="agreeTerms" checked={form.agreeTerms} onChange={handle}
                    style={{ marginTop:"2px", accentColor:pink, width:"17px", height:"17px", cursor:"pointer" }} />
                  <span style={{ color:muted, fontSize:"13px", lineHeight:1.6 }}>
                    I confirm all information provided is accurate and complete. I understand that submitting false information may result in disqualification.
                    I agree to EHHI's <span style={{ color:pink, fontWeight:600 }}>Terms & Conditions</span> and <span style={{ color:pink, fontWeight:600 }}>Privacy Policy</span>.
                  </span>
                </label>
              </div>
            )}

            {/* ── STEP 5 ── */}
            {step === 5 && (
              <div className="sa">
                <SectionHead title="Review & Submit" subtitle="Please verify all your details before final submission" accent={pink} icon="✅" />
                <ReviewSection title="Personal Information" accent={blue}>
                  <RRow label="Full Name"        value={form.firstName + " " + form.lastName} />
                  <RRow label="Date of Birth"    value={form.dob} />
                  <RRow label="Gender"           value={form.gender} />
                  <RRow label="Nationality"      value={form.nationality} />
                  <RRow label="ID Number"        value={form.idNumber} />
                  <RRow label="Phone"            value={form.phone} />
                  <RRow label="Email"            value={form.email} />
                  <RRow label="Location"         value={[form.city, form.province].filter(Boolean).join(", ")} />
                </ReviewSection>
                <ReviewSection title="Academic Background" accent={blue}>
                  <RRow label="High School"      value={form.highSchool} />
                  <RRow label="Graduation Year"  value={form.graduationYear} />
                  <RRow label="Overall Average"  value={form.overallAverage ? form.overallAverage + "%" : ""} />
                  <RRow label="Maths Grade"      value={form.mathGrade} />
                  <RRow label="Biology Grade"    value={form.scienceGrade} />
                  <RRow label="English Grade"    value={form.englishGrade} />
                </ReviewSection>
                <ReviewSection title="Medical & Emergency" accent={pink}>
                  <RRow label="Conditions"       value={form.hasCondition === "Yes" ? form.conditions : "None reported"} />
                  <RRow label="Allergies"        value={form.allergies || "None"} />
                  <RRow label="Emergency Contact" value={[form.emergencyName, form.emergencyRelation ? "("+form.emergencyRelation+")" : ""].filter(Boolean).join(" ")} />
                  <RRow label="Emergency Phone"  value={form.emergencyPhone} />
                </ReviewSection>
                <ReviewSection title="Documents" accent={blue}>
                  <RRow label="ID / Passport"      value={form.idDoc           ? "✅ Confirmed" : "☐ Not confirmed"} />
                  <RRow label="Transcript"         value={form.transcript      ? "✅ Confirmed" : "☐ Not confirmed"} />
                  <RRow label="Photographs"        value={form.photo           ? "✅ Confirmed" : "☐ Not confirmed"} />
                  <RRow label="Medical Cert"       value={form.medicalCert     ? "✅ Confirmed" : "☐ Not confirmed"} />
                  <RRow label="Motivation Letter"  value={form.motivationLetter? "✅ Confirmed" : "☐ Not confirmed"} />
                </ReviewSection>

                {/* Error message */}
                {error && (
                  <div style={{ background:"rgba(233,30,140,0.07)", border:"1.5px solid rgba(233,30,140,0.3)", borderRadius:"10px", padding:"14px 18px", marginBottom:"12px", color:pink, fontSize:"13px", fontWeight:600 }}>
                    ⚠️ {error}
                  </div>
                )}
                {!form.agreeTerms && !error && (
                  <div style={{ background:"rgba(233,30,140,0.07)", border:"1.5px solid rgba(233,30,140,0.3)", borderRadius:"10px", padding:"14px 18px", color:pink, fontSize:"13px", fontWeight:600 }}>
                    ⚠️ You must agree to the Terms & Conditions in Step 4 before submitting.
                  </div>
                )}
              </div>
            )}

            {/* ── NAV BUTTONS ── */}
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:"32px", paddingTop:"24px", borderTop:"1px solid rgba(21,101,192,0.1)" }}>
              <button onClick={() => setStep(s => Math.max(s-1,1))} disabled={step===1} style={{ padding:"11px 26px", background:step===1?offWhite:white, border:"1.5px solid "+(step===1?"rgba(21,101,192,0.1)":"rgba(21,101,192,0.3)"), borderRadius:"10px", color:step===1?muted:blue, fontWeight:700, fontSize:"14px", cursor:step===1?"not-allowed":"pointer", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
                ← Back
              </button>

              <span style={{ color:muted, fontSize:"12px", fontWeight:600 }}>Step {step} of {STEPS.length}</span>

              {step < 5 ? (
                <button onClick={() => setStep(s => Math.min(s+1,5))} style={{ padding:"11px 28px", background:"linear-gradient(135deg,#E91E8C,#C2185B)", border:"none", borderRadius:"10px", color:white, fontWeight:800, fontSize:"14px", cursor:"pointer", fontFamily:"'Plus Jakarta Sans',sans-serif", boxShadow:"0 4px 16px rgba(233,30,140,0.3)" }}>
                  Continue →
                </button>
              ) : (
                <button
                  onClick={handleSubmit}
                  disabled={!form.agreeTerms || sending}
                  style={{ padding:"11px 28px", background: form.agreeTerms && !sending ? "linear-gradient(135deg,#1565C0,#0D47A1)" : "rgba(21,101,192,0.15)", border:"none", borderRadius:"10px", color: form.agreeTerms && !sending ? white : muted, fontWeight:800, fontSize:"14px", cursor: form.agreeTerms && !sending ? "pointer" : "not-allowed", fontFamily:"'Plus Jakarta Sans',sans-serif", boxShadow: form.agreeTerms && !sending ? "0 4px 16px rgba(21,101,192,0.3)" : "none", minWidth:"170px", display:"flex", alignItems:"center", justifyContent:"center", gap:"8px" }}>
                  {sending ? (
                    <>
                      <span style={{ width:"14px", height:"14px", border:"2px solid rgba(255,255,255,0.3)", borderTopColor:white, borderRadius:"50%", display:"inline-block", animation:"spin 0.7s linear infinite" }} />
                      Sending…
                    </>
                  ) : "Submit Application ✓"}
                </button>
              )}
            </div>
          </div>
        </div>

        <p style={{ textAlign:"center", color:muted, fontSize:"12px", marginTop:"32px" }}>
          © 2025 Essential Health Higher Institute (EHHI) · EHFAF · <span style={{ color:pink }}>admissions@ehhi.edu</span>
        </p>
      </div>

      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
